import { render, staticRenderFns } from "./SupplierGroupForm.vue?vue&type=template&id=74b6c590"
import script from "./SupplierGroupForm.vue?vue&type=script&lang=js"
export * from "./SupplierGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports